import React from "react";
import Image from "next/image";
import Section from "@/components/ui/section";
const data = [
  {
    id: "1",
    icon: "/images/icons/mobile.svg",
    value: "+91 98732 40682",
    href: "tel:+919873240682",
  },
  {
    id: "2",
    icon: "/images/icons/email.svg",
    value: "info@soulscale.org",
    href: "mailto:info@soulscale.org",
  },
  {
    id: "3",
    icon: "/images/icons/location.svg",
    value:
      "N0. 3/21, Ground Floor, Kaveriappa layout, Millers Tank Bund Road, Vasantnagar, Near Mahaveer Jain Hospital, Bengaluru, 560001",
    href: "https://maps.app.goo.gl/72YuSUx4BxGJG6Gh9",
  },
];
export default function ContactUs() {
  return (
    <Section className="w-full flex flex-col items-center justify-center lg:mt-8 mb-8 gap-4">
      <h2 className="w-full text-blue text-center [&>span]:text-lightBlue capitalize leading-tight heading">
        <span>Say</span> Hello!
      </h2>
      <div className="mt-8 flex lg:flex-row flex-col border-t-[0.5px] border-darkGrey/50 border-b-[0.5px] lg:justify-between lg:items-center gap-6 py-5">
        {data.map((e) => (
          <a
            href={e.href}
            target="_blank"
            rel="noreferrer"
            key={e.id}
            className="flex items-center gap-4 text-sm md:text-base text-darkGrey/70 hover:underline transition-all duration-300 ease"
          >
            <div className="relative w-10 h-10 shrink-0">
              <Image
                src={e.icon}
                alt="icon"
                fill
                className="object-center object-contain"
                sizes="(max-width: 479px) 100px, 100px"
              />
            </div>
            <span className="lg:max-w-[343px]">{e.value}</span>
          </a>
        ))}
      </div>
    </Section>
  );
}
